import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface section {
  id: number;
  name: string;
  schoolClassId: number;
  schoolId: string;
  totalEnrollment: number | null;
  mdmEnrollment: number | null;
  teacherId: number | null;
  isDeleted: boolean;
  createdBy: string;
  updatedBy: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface sectionState {
  sections: section[];
  loading: boolean;
  error: string | null;
}

const initialState: sectionState = {
  sections: [],
  loading: false,
  error: null,
};

const sectionSlice = createSlice({
  name: 'sections',
  initialState,
  reducers: {
    // Fetch sections
    fetchSectionsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSectionsSuccess: (state, action: PayloadAction<section[]>) => {
      state.loading = false;
      state.sections = action.payload;
      state.error = null;
    },
    fetchSectionsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Add section
    addSectionStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    addSectionSuccess: (state, action: PayloadAction<section>) => {
      state.loading = false;
      state.sections.push(action.payload);
      state.error = null;
    },
    addSectionFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update section
    updateSectionStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateSectionSuccess: (state, action: PayloadAction<section>) => {
      state.loading = false;
      const index = state.sections.findIndex(section => section.id === action.payload.id);
      if (index !== -1) {
        state.sections[index] = action.payload;
      }
      state.error = null;
    },
    updateSectionFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete section
    deleteSectionStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteSectionSuccess: (state, action: PayloadAction<number>) => {
      state.loading = false;
      state.sections = state.sections.filter(section => section.id !== action.payload);
      state.error = null;
    },
    deleteSectionFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchSectionsStart,
  fetchSectionsSuccess,
  fetchSectionsFailure,
  addSectionStart,
  addSectionSuccess,
  addSectionFailure,
  updateSectionStart,
  updateSectionSuccess,
  updateSectionFailure,
  deleteSectionStart,
  deleteSectionSuccess,
  deleteSectionFailure,
} = sectionSlice.actions;

export default sectionSlice.reducer;